// extracted by mini-css-extract-plugin
export default {"overlay":"loader_overlay__3EVFV","check":"loader_check__vb99f","loader":"loader_loader__bXY+W"};